import { useContext } from "react";
import { TreeDnDContext } from "./TreeDnDProvider";

export const useTreeDnD = () => {
  const context = useContext(TreeDnDContext);
  if (!context) {
    throw new Error("useTreeDnD must be used within TreeDnDProvider");
  }
  return context;
};

